
<div class="dropdown" @click="isOpen = !isOpen">
  <button class="dropdown-button">
    <span class="dropdown-button-text font-rubik">{{ page.name }}</span>
    <span class="dropdown-arrow">
      <img
        :class="{ 'rotate-up': isOpen, 'rotate-down': !isOpen }"
        src="@/images/header/drop-down-arrow.svg"
        alt="Arrow"
        class="arrow-icon"
      />
    </span>
  </button>
  <ul v-if="isOpen" class="dropdown-menu">
    <li
      v-for="(page, index) in page.pages"
      :key="index"
      @click="selectItem()"
      class="dropdown-item"
    >
      <a class="item-link" :href="page.slug">
        {{ page.name }}
      </a>
    </li>
  </ul>
</div>
